<template>

    <a class="download-link" :class="clase" :href="publicPath+file" :type="type" :download="downloadname">
        <img v-if="cover" class="download-cover" :src="publicPath+cover" alt="">
      <div class="download-info"> 
        <p class="download-documento">Documentos<span class="a11y-solo-lectura">.</span></p>
        <p class="download-contador">1 descarga disponible<span class="a11y-solo-lectura">.</span></p>
        <p class="download-nombre">{{ name }}<span class="a11y-solo-lectura">.</span></p>
        <p class="download-expediente">Expediente Científico<span class="a11y-solo-lectura">.</span></p>
        <p class="download-formato">
          {{ format }}
          <b>{{ weight }}</b><span class="a11y-solo-lectura">.</span>
          <span class="f1"></span>
          <arrow-down :size="24" />
        </p>
      </div>
    </a>


</template>

<script>
import ArrowDown from 'vue-material-design-icons/ArrowDownCircle.vue'

export default {
  name: 'DownloadImportantFileBajo',
  components: {
    ArrowDown
  },
  props: {
    file: String,
    type: String,
    format: String,
    name: String,
    downloadname: String,
    weight: String,
    cover: String,
    clase: String
  },
  methods: {},
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {},
}
</script>

<style scoped lang="scss">
.download-link {
  display: block;
  .download-cover {
    display: block;
    border-radius: $border-radius;
    border: 1px solid rgba(0,0,0,.1);
    box-shadow: 0 4px 10px rgba(0,0,0,.1);
    overflow: hidden;
    transition: box-shadow .27s ease-in-out;
    box-sizing: content-box;
    width: 100%;
  }
  .download-info {
    border-bottom: 1px solid #ccc;
    color: #000;
    .download-contador,
    .download-documento {
      display: none;
        @media (min-width: map-get($media-queries-limit, "mobile")) {
        margin-top: 5px;
        }
    }
    .download-nombre {
      font-weight: 500;
      margin:0;
    }
    .download-expediente {
      margin: 0;
      
    }
    .download-formato {
      font-size: 14px;
      display: flex;
      align-items: center;
      margin: 0;
      b {
        padding: 0 8px;
      }
      .f1 {
        flex: 1;
      }
    }
  }
  
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: grid;
    grid-template-columns: 1fr 2fr;
    .download-info {
      margin-left: $gap;
      display: flex;
      flex-direction: column;
      transition: all .2s ease-in-out;
      .download-documento,
      .download-contador,
      .download-nombre,
      .download-expediente,
      .download-formato {
        transition: all .2s ease-in-out;
        padding-left: 0;
      }
      .download-documento {
        border-top: 1px solid #000;
        border-bottom: 1px solid #000;
        display: block;
        padding: 16px 0;
        margin: 0;
        font-size: 24px;
        font-weight: 500;
      }
      .download-contador {
        display: block;
      }
      .download-nombre {
        font-size: 20px;
      }
      .download-expediente {
        margin: 0;
        margin-top: 15px

      }
      .download-formato {
        margin: 0;
      }
      .f1 {
        flex: 1;
      }
    }
    &:hover, 
    &:focus {
      background: none;
      
      .download-cover {
        box-shadow: 0 4px 10px rgba(0,0,0,.5);
      }
      .download-info {
        margin-left: 0;
        // padding-left: $gap;
        color: map-get($color-link, "hover-fondo");
        border-bottom-color: map-get($color-link, "hover-fondo");
        .download-documento {
          border-top-color: map-get($color-link, "hover-fondo");
          border-bottom-color: map-get($color-link, "hover-fondo");
          font-weight: bold;
        }
        .download-documento,
        .download-contador,
        .download-nombre,
        .download-expediente,
        .download-formato {
          transition: all .2s ease-in-out;
          padding-left: $gap;
        }
      }
      // .download-icon {
      //   color: $accion;
      //   .material-design-icon {
      //     margin-top: $font-size-base*.5;
      //   }
      // }
    }
  }
}
</style>
